import styled, { css } from 'styled-components';

import { Button, Form } from 'components/shared';
import { Input as ClerkInput } from 'components/project/ClerkScreen';
import {
  Button as ClerkButton,
  lightenDarkenColor,
} from '../../components/project/ClerkScreen/shared/utils/styles';

export const Container = styled.div`
  display: grid;
  height: 100vh;
  width: 100vw;
  align-content: center;
  justify-content: center;
  * {
    color: #3d3d3d;
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.6em;
  font-weight: bold;
  margin-bottom: 1em;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  & img,
  img:hover {
    height: auto;
    max-width: 200px;
    border: 0px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  border: 1px solid gray;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  width: 75vw;
  padding: 20px;
  min-height: 150px;
  @media (min-width: 600px) {
    width: 50vw;
  }
  @media (min-width: 861px) {
    width: 35vw;
  }
  @media (min-width: 1201px) {
    width: 25vw;
  }
`;

export const Title = styled.h1``;

export const FormContainer = styled.div`
  display: flex;
  justify-content: left;
`;

export const LoginContainer = styled.div`
  border: 1px solid red;
`;

export const FormElement = styled(Form.Element)`
  width: calc(100% - 50px);
  max-width: 400px;
`;

export const ActionButton = styled(Button)`
  width: 100px;
  font-size: 1em;
  margin-bottom: 10px;
`;

export const InlineFormFieldContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const CenterInlineContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 100%;
`;

export const AuctionLaneSelectionContainer = styled.div`
  padding: 20px;
`;
export const LoginForm = styled.form`
  width: 95%;
  min-height: 150px;
`;

export const LoginInput = styled(ClerkInput)``;

export const LoginButton = styled(ClerkButton)`
  height: 30px;
  width: 100%;
  margin-top: 20px;
  padding: 10px 20px;
  height: 40px;
  font-weight: normal;
  background-color: #a62b2b;
  border-color: #a62b2b;
  color: #ffffff;
  &:disabled {
    border-color: #ccc;
  }
  &:hover {
    background-color: ${lightenDarkenColor('#a62b2b', 20)};
    color: #ffffff;
  }
  & i {
    color: #ffffff;
    padding-right: 5px;
    font-size: 1em;
  }
`;

export const LoginLabel = styled.label`
  font-size: 1em;
  font-weight: bold;
`;

export const WatchModeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 5px;
  & input {
    margin-right: 10px;
  }
`;

export const BlockFormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 5px;
  & label {
    font-weight: bold;
    font-size: 1em;
    min-width: 100%;
  }
  & input {
    min-width: 97%;
    margin-bottom: 10px;
    font-size: 1.2em;
    padding: 5px;
    border: 1px solid gray;
    border-radius: 3px;
    &::placeholder {
      color: rgba(0, 0, 0, 0.3);
    }
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
    }
  }
  & input[type=checkbox] {
    
  }  
  & select {
    width: 100%;
    min-width: 100%;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 3px;
  }
  & button {
    width: 95%;
    min-width: 100%;
  }
`;

export const Description = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 350px;
  margin: 0px 0px 20px 0px;
  & i {
    padding-right: 10px;
  }
`;

export const Text = styled.div`
  font-size: 1em;
`;

export const Error = styled.p`
  color: red;
  text-align: center;
`;

export const NextButton = styled(ClerkButton)`
  height: 30px;
  width: 100%;
  margin-top: 20px;
  padding: 10px 20px;
  height: 40px;
  font-weight: normal;
  background-color: #a62b2b;
  border-color: #a62b2b;
  color: #ffffff;
  &:hover {
    background-color: ${lightenDarkenColor('#a62b2b', 20)};
    color: #ffffff;
  }
  & i {
    color: #ffffff;
    padding-left: 15px;
    font-size: 1em;
  }
`;

export const ChangeAuctionButton = styled(ClerkButton)`
  width: 80%;
  margin: 10px auto;
  padding: 10px 20px;
  height: auto;
  font-weight: normal;
  background-color: #ccc;
  border-color: #000;
  color: #000;
  font-size: 0.8rem;
  &:hover {
    background-color: ${lightenDarkenColor('#a62b2b', 20)};
    color: #ffffff;
  }
  & i {
    color: #ffffff;
    padding-right: 5px;
    font-size: 1em;
  }
`;

export const ChangeAuctionButtonContainer = styled.div`
  text-align: center;
`;

export const IssuesContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  && button {
    width: 50px;
    max-width: 50px;
    text-decoration: underline;
    border: 1px solid red;
  }
  && button > i {
    margin-right: 3px;
    font-size: 0.8em;
  }
`;

export const ResetButton = styled(LoginButton)`
  ${({ bgColor }) =>
    bgColor &&
    css`
      border-color: ${bgColor};
      background-color: ${bgColor};
      :hover {
        background-color: ${bgColor};
      }
    `}
`;
